const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const formatDate = (value: string | null | undefined): string => {
    if (!value) return ''

    const [year, month, day] = value.slice(0, 10).split('-').map(Number)

    if (!year || !month || !day) return value

    return `${MONTHS[month - 1]} ${day}, ${year}`
}
